import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { MdAdd, MdBrightness2, MdCancel, MdDelete, MdSave } from 'react-icons/md';
import { Button } from 'reactstrap';;
// import { UpdateDashboardTitle } from './update-dashboard-title';
import { DASHBOARD_MODE, IDashboard } from './utils/utils';
import { UpdateDashboardTitle } from './update-dashboard-title';
import TimeRangeWidget, { TimeRange } from './timeRange';

type ToolbarProps = {
  mode: DASHBOARD_MODE;
  title: string;
  dashboard?: IDashboard;
  timeRangeValue?: TimeRange;
  onCancel?: () => void;
  onEdit?: () => void;
  onSave?: () => void;
  saveTitle: (title: string) => void;
  onTimeRangeChange?: (timeRange: string) => void;
  onDelete?: () => void;
  onAdd?: () => void;
  onChangeTheme?: (val: boolean) => void;
  loggedInUser: string | number;
  darkTheme?: boolean;
};

export const Toolbar = (props: ToolbarProps): JSX.Element => {
  const isEditable =  true //props.loggedInUser === props.dashboard?.userId;
  
  return (
    <div className="db-toolbar">
      <UpdateDashboardTitle title={props.title} saveTitle={props.saveTitle} />
      {props.mode === 'edit' ? (
        <EditToolBar {...props} />
      ) : (
        <div className="db-view-actions">
          <TimeRangeWidget onChange={props.onTimeRangeChange} timeRange={props.timeRangeValue} />
          {isEditable && (
            <Button color="primary" type="button" onClick={props.onEdit}>
              <FontAwesomeIcon icon="pencil-alt" />
              {' '}Edit Dashboard
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

const EditToolBar = (props: ToolbarProps) => (
  <>
    <div className="db-edit-actions">
      <DarkTheme handleClick={props.onChangeTheme} darkTheme={props.darkTheme} />
      <SaveIcon handleClick={props.onSave} />
      <AddIcon handleClick={props.onAdd} />
      {props.dashboard && props.dashboard.id && <DeleteIcon handleClick={props.onDelete} />}
      <CancelIcon handleClick={props.onCancel} />
    </div>
  </>
);

const CancelIcon = ({ handleClick }: { handleClick?: () => void }) => {
  return (
    <div className="box" onClick={handleClick} title="Cancel">
      <div className="box-icon">
        <MdCancel />
      </div>
    </div>
  );
};

const SaveIcon = ({ handleClick }: { handleClick?: () => void }) => {
  return (
    <div className="box" onClick={handleClick} title="Save">
      <div className="box-icon">
        <MdSave />
      </div>
    </div>
  );
};

const AddIcon = ({ handleClick }: { handleClick?: () => void }) => {
  return (
    <div className="box" onClick={handleClick} title="Add Widget">
      <div className="box-icon">
        <MdAdd />
      </div>
    </div>
  );
};

const DeleteIcon = ({ handleClick }: { handleClick?: () => void }) => {
  return (
    <div className="box" onClick={handleClick} title="Delete Dashboard">
      <div className="box-icon">
        <MdDelete />
      </div>
    </div>
  );
};

const DarkTheme = ({ handleClick, darkTheme }: { handleClick?: (val: boolean) => void; darkTheme?: boolean }) => {
  return (
    <div
      className="box"
      style={darkTheme ? { background: '#345587', color: '#fff' } : {}}
      onClick={() => {
        handleClick?.(!darkTheme);
      }}
      title={darkTheme ? 'Enable Light Theme' : 'Enable Dark Theme'}
    >
      <div className="box-icon">
        <MdBrightness2 />
      </div>
    </div>
  );
};

export default Toolbar;
